import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Link,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WButton } from '@wareclouds/wareclouds-ui';

function showSupport() {
  if (typeof window.Intercom === 'function') window.Intercom('show');
}

export default function IdentityValidationResultDialog({
  open,
  pending,
  onClose,
  onStartRoute,
}) {
  const { t } = useTranslation(['title', 'description', 'button']);

  if (pending) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: '8px',
            m: 2,
            width: 'calc(100% - 32px)',
            boxShadow: '0px 8px 24px rgba(33, 33, 33, 0.18)',
          },
        }}
      >
        <DialogContent sx={{ px: 3, pt: 4, pb: 3, textAlign: 'center' }}>
          <SearchOutlinedIcon sx={{ fontSize: 40, color: '#9E9E9E', mb: 2 }} />
          <Typography
            component="h2"
            sx={{
              fontSize: 20,
              fontWeight: 600,
              lineHeight: 1.3,
              color: '#212121',
              mb: 2,
            }}
          >
            {t('identity_validation.pending_title', { ns: 'title' })}
          </Typography>
          <Typography sx={{ fontSize: 14, lineHeight: 1.5, color: '#424242' }}>
            {t('routes.identity_validation.pending_description', {
              ns: 'description',
            })}
          </Typography>

          <Box sx={{ borderBottom: '1px solid #E0E0E0', my: 2 }} />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              textAlign: 'left',
            }}
          >
            <InfoOutlinedIcon sx={{ color: '#777777', fontSize: 22 }} />
            <Typography
              sx={{ fontSize: 14, color: '#6B6B6B', lineHeight: 1.4 }}
            >
              {t('routes.identity_validation.support_prefix', {
                ns: 'description',
              })}{' '}
              <Link
                component="button"
                type="button"
                underline="always"
                onClick={showSupport}
                sx={{ color: 'primary.main', fontSize: 'inherit' }}
              >
                {t('routes.identity_validation.support_link', {
                  ns: 'description',
                })}
              </Link>
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <DialogContent sx={{ textAlign: 'center', py: 4 }}>
        <Box sx={{ mb: 2 }}>
          <CheckCircleOutlineIcon sx={{ fontSize: 56 }} />
        </Box>
        <Typography variant="h6">
          {t('identity_validation.success_title', { ns: 'title' })}
        </Typography>
        <Typography sx={{ mt: 1 }}>
          {t('routes.identity_validation.success_description', {
            ns: 'description',
          })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <WButton
          label={t('identity_validation.start_route', { ns: 'button' })}
          onClick={onStartRoute}
          fullWidth
        />
      </DialogActions>
    </Dialog>
  );
}
